import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment as ENV } from '../../environments/environment';
import {
    INotification, INotificationEdit, INotificationInboxListItem, INotificationInboxStatus,
    INotificationListItem, INotificationUserChannel
} from '../models/Notification';

/**
 * Notification service
 */
@Injectable({ providedIn: "root" })
export class NotificationService {
    constructor(public http: HttpClient) { }

    public get apiUrl(): string { return `${ENV.apiUrl}/notifications` }

    get(limit?: number): Observable<{ Items: INotificationListItem[], HasMore: boolean }> {
        return this.http.get<{ Items: INotificationListItem[], HasMore: boolean }>(this.apiUrl, { params: { limit } });
    }

    getById(id: number): Observable<INotification> {
        const url = `${this.apiUrl}/${id}`;
        return this.http.get<INotification>(url);
    }

    getInbox(): Observable<INotificationInboxListItem[]> {
        const url = `${this.apiUrl}/inbox`;
        return this.http.get<INotificationInboxListItem[]>(url);
    }

    getInboxStatus(id: number): Observable<INotificationInboxStatus[]> {
        const url = `${this.apiUrl}/inbox/${id}/status`;
        return this.http.get<INotificationInboxStatus[]>(url);
    }

    send(id: number, data: INotificationEdit): Observable<any> {
        const url = `${this.apiUrl}/${id}/send`;
        return this.http.put<any>(url, data);
    }

    getUserChannels(): Observable<INotificationUserChannel[]> {
        const url = `${this.apiUrl}/userChannels`;
        return this.http.get<INotificationUserChannel[]>(url);
    }

    updateUserChannels(
        notificationTypeId: string,
        channels: {
            isMyRsuEnabled?: boolean,
            isRsuEmailEnabled?: boolean,
            isSmsEnabled?: boolean
        }
    ): Observable<any> {
        const url = `${this.apiUrl}/userChannels`;
        return this.http.put(url, { notificationTypeId, ...channels });
    }
}
